import React, { memo, useCallback, useState } from 'react'

import { Button, TextInput } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

function PasteUrlArea({ isLoading, onPasteUrlUpload: handlePasteUrlUpload }) {
  const t = useTranslation()
  const [url, setUrl] = useState('')

  const handleUploadImageClick = useCallback(() => {
    handlePasteUrlUpload(url).then((success) => {
      if (success) {
        setUrl('')
      }
    })
  }, [url, handlePasteUrlUpload])

  const handleUrlChange = useCallback((e) => {
    setUrl(e.target.value)
  }, [setUrl])

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      handleUploadImageClick()
    }
  }, [handleUploadImageClick])

  return (
    <div className="image-uploader__paste-url-area">
      <TextInput
        id="paste-url-input"
        isPilot
        size="small"
        textInputClassName="image-uploader__paste-url-field"
        placeholder={t('shared.actionSelector.imageUploader.pasteUrl.placeholder')}
        value={url}
        onChange={handleUrlChange}
        onKeyDown={handleKeyDown}
        isDisabled={isLoading}
        trailButton={(
          <Button
            type="secondary"
            size="tiny"
            customClass="image-uploader__button"
            onClick={handleUploadImageClick}
            disabled={isLoading || !url.trim()}
          >
            {t('shared.actionSelector.imageUploader.pasteUrl.upload')}
          </Button>
        )}
      />
    </div>
  )
}

PasteUrlArea.propTypes = {
  isLoading: bool.isRequired,
  onPasteUrlUpload: func.isRequired,
}

export default memo(PasteUrlArea)
